import { get, set, del, clear, createStore } from "idb-keyval";
/**
 * IndexedDB-based key-value database implementation using idb-keyval
 * @example
 * ```ts
 * const db = new IndexedDBKv<{ user: User; settings: Settings }>();
 * await db.set('user', userData);
 * const user = await db.get('user');
 * ```
 */
export class IndexedDBKv {
    store;
    constructor(dbName = "keyval-store", storeName = "keyval") {
        this.store = createStore(dbName, storeName);
    }
    /** Retrieves a value from IndexedDB */
    get = (key) => get(String(key), this.store).then((x) => x ?? null);
    /** Stores a value in IndexedDB */
    set = (key, value) => set(String(key), value, this.store);
    /** Removes a value from IndexedDB */
    del = (key) => del(String(key), this.store);
    /** Removes all values from IndexedDB */
    clear = () => clear(this.store);
}
//# sourceMappingURL=idb.js.map